export const translations = {
  tr: {
    // Header
    'header.themes': 'Temalar',
    'header.todo': 'Todo',
    'header.social': 'Sosyal',
    'header.home': 'Ana Sayfa',
    'header.dashboard': 'Pano',
    'header.advancedReports': 'Gelişmiş Raporlar',
    'header.report': 'Rapor',
    'header.settings': 'Ayarlar',
    'header.login': 'Giriş Yap',
    'header.logout': 'Çıkış Yap',
    'header.profilePhoto': 'profil fotoğrafı',

    // Domain notice
    'domainNotice.label': 'Yeni adres duyurusu',
    'domainNotice.title': 'Taşındık. Kutular mutular tamam, kedi de sağ salim.',
    'domainNotice.newAddress': 'Yeni evimiz',
    'domainNotice.countdown': 'Eski adres {days} gün sonra kapanıyor; bookmark\'ını falan şimdiden güncelle de sonra yok efendim “kedi bi\' şey yaptı” demeyelim.',
    'domainNotice.close': 'Duyuruyu kapat',
    
    // Timer
    'timer.pomodoro': 'Pomodoro',
    'timer.shortBreak': 'Kısa Mola',
    'timer.longBreak': 'Uzun Mola',
    'timer.start': 'BAŞLAT',
    'timer.stop': 'DURDUR',
    'timer.sessionGoal': 'Bu seansta neyi bitirmek istiyorsun?',
    'timer.sessionGoalPlaceholder': 'Tek, net bir hedef yaz...',
    'timer.noGoal': 'Bu seans için hedef seçmedin',
    'timer.emergencyStart': 'Sadece 5 dakika başla',
    'timer.adaptiveTitle': 'Sana uygun bir süre',
    'timer.sessionsBased': 'seansa göre',
    'timer.completion': 'tamamlama',
    'timer.try': 'dene',
    'timer.notNow': 'Şimdi değil',
    'timer.averageDuration': 'Ortalama',
    'timer.scope.general': 'Genel çalışma ritmin',
    'timer.scope.project': 'Bu projedeki ritmin',
    'timer.scope.task': 'Bu görevdeki ritmin',
    'timer.goalRequiredAlert': 'Başlamadan önce bu seansın net hedefini yaz.',
    'timer.quickSettings': 'Zamanlayıcı ayarları',
    
    // Tasks
    'tasks.activeTasks': 'Aktif Görevler',
    'tasks.noTasks': 'Bu proje için görev yok.',
    'tasks.addTask': 'Yeni görev ekle...',
    'tasks.addProject': 'Yeni proje oluştur...',
    'tasks.addProjectButton': 'Proje Ekle',
    'tasks.completeProject': 'Bitir',
    'tasks.completeProjectTooltip': 'Projeyi bitirmek için önce tüm görevleri tamamlayın.',
    'tasks.completeProjectTooltip2': 'Projeyi tamamla ve vitrine taşı.',
    'tasks.deleteProjectTooltip': 'Son kalan projeyi silemezsiniz.',
    'tasks.deleteProjectTooltip2': 'Projeyi ve içindeki tüm görevleri sil.',
    'tasks.pomodoro': 'Pomodoro',
    'tasks.minutes': 'dk',
    'tasks.estimate': 'Tahmin',
    'tasks.remaining': 'kaldı',

    // Todo
    'todo.title': 'Todo',
    'todo.subtitle': 'Yapacaklarını toparla, gününü planla.',
    'todo.search': 'Görevlerde ara',
    'todo.myDay': 'Günüm',
    'todo.important': 'Önemli',
    'todo.planned': 'Planlanan',
    'todo.all': 'Tüm görevler',
    'todo.completed': 'Tamamlanan',
    'todo.lists': 'Listeler',
    'todo.newList': 'Yeni liste',
    'todo.addList': 'Liste ekle',
    'todo.listView': 'Liste',
    'todo.boardView': 'Pano',
    'todo.addTask': 'Görev ekle',
    'todo.addTaskPlaceholder': 'Yeni görev yaz...',
    'todo.details': 'Görev ayrıntıları',
    'todo.taskName': 'Görev adı',
    'todo.note': 'Not',
    'todo.notePlaceholder': 'Bu görev hakkında not ekle...',
    'todo.dueDate': 'Son tarih',
    'todo.list': 'Liste',
    'todo.addToMyDay': 'Günüm listesine ekle',
    'todo.removeFromMyDay': 'Günüm listesinden çıkar',
    'todo.sendToActiveTasks': 'Aktif görevlere gönder',
    'todo.inActiveTasks': 'Aktif görevlerde',
    'todo.markImportant': 'Önemli olarak işaretle',
    'todo.removeImportant': 'Önem işaretini kaldır',
    'todo.deleteTask': 'Görevi sil',
    'todo.deleteTaskConfirm': 'Bu görev kalıcı olarak silinsin mi?',
    'todo.deleteList': 'Listeyi sil',
    'todo.deleteListConfirm': 'Bu liste ve içindeki görevler kalıcı olarak silinsin mi?',
    'todo.emptyTitle': 'Burada her şey tamam',
    'todo.emptyText': 'Yeni bir görev ekleyerek başlayabilirsin.',
    'todo.noResults': 'Aramana uyan görev bulunamadı.',
    'todo.tasksCount': 'görev',
    'todo.pomodoros': 'pomodoro tamamlandı',
    'todo.loading': 'Listelerin hazırlanıyor...',
    'todo.loadError': 'Listelerini şu an açamadık.',
    'todo.saveError': 'Değişikliği kaydedemedik.',
    'todo.listLimitError': 'Bu liste tek seferde silinemeyecek kadar fazla görev içeriyor.',
    'todo.syncHint': 'Değişiklikler Pomofree hesabında saklanır.',
    'todo.closeDetails': 'Ayrıntıları kapat',
    'todo.estimate': 'Tahmini Pomodoro',
    'todo.remaining': 'kaldı',

    // Social
    'social.title': 'Sosyal',
    'social.heroEyebrow': 'Pomofree topluluğu',
    'social.heroTitle': 'Pomofree\'de neler oluyor?',
    'social.heroText': 'Pomofree\'de tamamlanan odak seansları burada bir araya geliyor. İstersen kısa bir not bırak, istersen sadece göz at.',
    'social.liveData': 'Canlı veriler',
    'social.activePeople': 'kullanıcı kayıtlı',
    'social.totalMinutes': 'dakika odaklanıldı',
    'social.refresh': 'Yenile',
    'social.refreshing': 'Yenileniyor',
    'social.guestTitle': 'İçeriği görmek için giriş yap',
    'social.guestText': 'Haftalık liste ve paylaşımlar yalnızca giriş yapan kullanıcılara açık.',
    'social.guestButton': 'Girişe dön',
    'social.guestSharePlaceholder': 'Paylaşmak için giriş yap',
    'social.weekLabel': 'Topluluk özeti',
    'social.myWeek': 'Senin toplamın',
    'social.focusTime': 'Odak süresi',
    'social.completedSessions': 'Tamamlanan seans',
    'social.activeDays': 'Aktif gün',
    'social.noPersonalStats': 'Henüz tamamlanmış seansın yok.',
    'social.leadersTitle': 'Genel liste',
    'social.leadersText': 'Bugüne kadar tamamlanan Pomofree seanslarına göre oluşur.',
    'social.focusChampions': 'Süre',
    'social.finishers': 'Seans',
    'social.versatile': 'Proje',
    'social.minutes': 'dk',
    'social.sessions': 'seans',
    'social.projects': 'proje',
    'social.days': 'gün',
    'social.emptyLeaders': 'Liste, ilk seans tamamlanınca dolacak.',
    'social.communityEyebrow': 'Ortak alan',
    'social.communityTitle': 'İlerleme paylaştıkça çoğalır.',
    'social.communityText': 'Bir zaferi kutla, takıldığın yeri sor ya da bir başkasına küçük bir destek bırak.',
    'social.syncHint': 'Odak özetin paylaşılır; adın ve fotoğrafın yalnızca izin verirsen görünür.',
    'social.feedEyebrow': 'Topluluk akışı',
    'social.feedTitle': 'Akış',
    'social.feedText': 'Ne yaptın, nerede takıldın? Kısaca yaz.',
    'social.sharePlaceholder': 'Bugün nasıl gidiyor?',
    'social.mood': 'Not türü',
    'social.mood.progress': 'İlerliyorum',
    'social.mood.victory': 'Bitti',
    'social.mood.question': 'Bir şey soracağım',
    'social.mood.break': 'Moladayım',
    'social.share': 'Paylaş',
    'social.emptyFeed': 'Henüz kimse yazmamış. İstersen ilk notu sen bırak.',
    'social.reaction.support': 'Yanındayım',
    'social.reaction.spark': 'İyiymiş',
    'social.reaction.focus': 'Hadi devam',
    'social.comments': 'Yorumlar',
    'social.hideComments': 'Yorumları kapat',
    'social.noComments': 'Henüz yorum yok.',
    'social.commentPlaceholder': 'Bir şey yaz',
    'social.commentSubmit': 'Gönder',
    'social.delete': 'Sil',
    'social.deleteConfirm': 'Bu notu silmek istediğine emin misin?',
    'social.now': 'Şimdi',
    'social.loading': 'Sosyal alan açılıyor...',
    'social.loadError': 'Sosyal alan şu an açılmadı. Biraz sonra tekrar dene.',
    'social.saveError': 'Kaydedemedik. Bir kez daha deneyebilirsin.',
    'social.settings': 'Sosyal ayarları',
    'social.settingsText': 'Toplulukta nasıl görüneceğini buradan seçebilirsin.',
    'social.publicProfile': 'Adımı ve profil fotoğrafımı herkese göster',
    'social.publicProfileHelp': 'Kapalıyken adın L** N**** gibi maskelenir ve fotoğrafın gösterilmez.',
    'project.settings': 'Proje ayarları',
    'project.name': 'Proje adı',
    'project.description': 'Açıklama',
    'project.target': 'Hedef Pomodoro',
    'project.dailyTarget': 'Günlük hedef',
    'project.dueDate': 'Son tarih',
    'project.priority': 'Öncelik',
    'project.color': 'Renk',
    'project.low': 'Düşük',
    'project.normal': 'Normal',
    'project.high': 'Yüksek',
    'project.archive': 'Projeyi arşivle',
    'project.archiveConfirm': 'Bu proje arşivlensin mi? Görevleri korunacak.',
    'project.completedPomodoros': 'tamamlanan',
    'project.remainingPomodoros': 'tahmini kalan',
    'project.estimatedFinish': 'tahmini bitiş',
    'project.deadlineRisk': 'son tarih riski',
    'project.inactivePrefix': 'Bu projede',
    'project.inactiveSuffix': 'gündür seans başlatmadın. Devam etmek, düzenlemek veya arşivlemek ister misin?',
    'project.review': 'Projeyi gözden geçir',

    // Focus flow
    'focus.tools': 'Odak araçları',
    'focus.sessionActive': 'Şu an odaktasın',
    'focus.sessionReady': 'Odak köşesi',
    'focus.notes': 'not',
    'focus.interruptions': 'kesinti',
    'focus.thoughtParking': 'Aklıma Geldi',
    'focus.interrupted': 'Kesildim',
    'focus.sounds': 'Odak Sesleri',
    'focus.thoughtPrompt': 'Aklına takılanı buraya bırak; sonra dönersin.',
    'focus.thoughtPlaceholder': 'Sonra bakacağın şeyi yaz...',
    'focus.save': 'Kaydet',
    'focus.interruptionReason': 'Seni ne böldü?',
    'focus.optionalNote': 'İstersen kısa bir not ekle',
    'focus.phone': 'Telefon',
    'focus.notification': 'Bildirim',
    'focus.person': 'İnsan',
    'focus.water': 'Tuvalet / su',
    'focus.otherTask': 'Başka görev',
    'focus.internal': 'İçsel dikkat',
    'focus.technical': 'Teknik sorun',
    'focus.other': 'Diğer',
    'focus.completeNote': 'Notu tamamlandı olarak işaretle',
    'focus.toTask': 'Göreve dönüştür',
    'focus.deleteNote': 'Notu sil',
    'focus.smartBreak': 'Mola önerisi',
    'focus.break.water': 'Bir bardak su iç.',
    'focus.break.stretch': 'Omuzlarını ve boynunu nazikçe hareket ettir.',
    'focus.break.eye': '20 saniye boyunca uzağa bak ve ekran ışığından dinlen.',
    'focus.break.walk': 'Masadan kalk, biraz yürü ve omuzlarını hareket ettir.',
    'focus.break.plan': 'Bir sonraki seansın tek hedefini belirle.',
    'focus.sessionComplete': 'Seans tamamlandı',
    'focus.reviewTitle': 'Nasıl geçti?',
    'focus.result': 'Sonuç',
    'focus.completed': 'Tamamlandı',
    'focus.partial': 'Kısmen tamamlandı',
    'focus.notCompleted': 'Tamamlanmadı',
    'focus.distracted': 'Dikkatim dağıldı',
    'focus.focusLevel': 'Odak',
    'focus.difficulty': 'Zorluk',
    'focus.energy': 'Enerji',
    'focus.low': 'Düşük',
    'focus.normal': 'Normal',
    'focus.high': 'Yüksek',
    'focus.easy': 'Kolay',
    'focus.hard': 'Zor',
    'focus.reviewNote': 'Kısa not (isteğe bağlı)',
    'focus.skip': 'Atla',
    'focus.saveReview': 'Değerlendirmeyi kaydet',
    'focus.fiveDone': 'Beş dakikayı tamamladın. Nasıl devam edelim?',
    'focus.continueTen': '10 dakika daha',
    'focus.switchNormal': 'Normal Pomodoro',
    'focus.commandPalette': 'Komut paleti',
    'focus.commandSearch': 'Bir işlem ara...',
    'focus.pauseAfterInterruption': 'Sayacı duraklatmak ister misin?',
    'focus.reviewSaveError': 'Değerlendirme kaydedilemedi. Seans süren yine de Pomofree hesabında saklandı.',
    'focusSound.title': 'Odak Ses Mikseri',
    'focusSound.projectProfile': 'Bu proje için otomatik saklanır',
    'focusSound.rain': 'Yağmur',
    'focusSound.cafe': 'Kafe',
    'focusSound.keyboard': 'Klavye',
    'focusSound.train': 'Tren',
    'focusSound.brown': 'Brown noise',
    'focusSound.white': 'White noise',
    'focusSound.fire': 'Şömine',
    'focusSound.nature': 'Doğa',
    'focusSound.focusLevel': 'Odakta tam, molada düşük ses',
    'focusSound.breakLevel': 'Mola seviyesi (%25)',
    'focusSound.muteAll': 'Tümünü kapat',
    
    // Settings Modal
    'settings.title': 'Ayarlar',
    'settings.pomodoro': 'Pomodoro Süresi (dakika)',
    'settings.shortBreak': 'Kısa Mola Süresi (dakika)',
    'settings.longBreak': 'Uzun Mola Süresi (dakika)',
    'settings.save': 'Kaydet',
    'settings.cancel': 'İptal',
    'settings.timerSection': 'Sayaç',
    'settings.quickTimerTitle': 'Zamanlayıcıyı ayarla',
    'settings.profileSection': 'Profil',
    'settings.profilePhotoUrl': 'Profil fotoğrafı adresi',
    'settings.profilePhotoUrlPlaceholder': 'https://ornek.com/fotograf.webp',
    'settings.uploadPhoto': 'Fotoğraf yükle',
    'settings.removePhoto': 'Fotoğrafı kaldır',
    'settings.profilePhotoHelp': 'JPG, PNG veya WebP seçebilirsin. Dosya 128×128 boyutuna küçültülüp Firestore için sıkıştırılır.',
    'settings.profilePhotoError': 'HTTPS adresi veya 5 MB altı JPG, PNG ya da WebP kullan.',
    'settings.socialSection': 'Sosyal gizlilik',
    'settings.socialProfilePublic': 'Adımı ve profil fotoğrafımı sosyal alanda göster',
    'settings.socialProfileHelp': 'Kapalıyken adın maskelenir ve profil fotoğrafın yalnızca sende kalır.',
    'settings.emergencyMinutes': 'Acil başlama süresi (3–10 dakika)',
    'settings.focusFlow': 'Odak akışı',
    'settings.goalRequired': 'Seans hedefini zorunlu tut',
    'settings.notifications': 'Masaüstü bildirimleri',
    'settings.notifySessionEnd': 'Seans bittiğinde',
    'settings.notifyBreakEnd': 'Mola bitişi ve dönüş zamanı',
    'settings.notifyLongBreak': 'Uzun mola zamanı',
    'settings.notifyRoomStarted': 'Ortak çalışma odası başladığında',
    'settings.notifyParticipantJoined': 'Odaya biri katıldığında',
    'settings.adaptive': 'Adaptif süre önerileri',
    'settings.adaptiveFrequency': 'Öneri sıklığı',
    'settings.frequencyFrequent': 'En fazla günde bir',
    'settings.frequencyBalanced': 'En fazla üç günde bir',
    'settings.frequencyRare': 'En fazla haftada bir',
    'settings.breakTips': 'Akıllı mola önerileri',
    'settings.breakMovement': 'Hareket önerileri',
    'settings.breakEyes': 'Göz dinlendirme önerileri',
    'settings.breakHydration': 'Su hatırlatmaları',
    'settings.breakPlanning': 'Sonraki seansı planlama',
    'settings.interruptionAction': 'Kesinti kaydedildiğinde sayaç',
    'settings.keepRunning': 'Çalışmaya devam etsin',
    'settings.autoPause': 'Otomatik duraklasın',
    'settings.askMe': 'Her seferinde sorsun',
    'settings.accessibility': 'Erişilebilirlik',
    'settings.reducedMotion': 'Hareketleri azalt',
    'settings.highContrast': 'Yüksek kontrast',
    'settings.colorVision': 'Renk görme desteği',
    'settings.colorDefault': 'Varsayılan',
    'settings.colorGreen': 'Yeşil ayrımı desteği',
    'settings.colorRed': 'Kırmızı ayrımı desteği',
    'settings.colorBlue': 'Mavi ayrımı desteği',
    'settings.shortcuts': 'Klavye kısayolları',
    'settings.shortcutsEnabled': 'Kısayollar etkin',
    'settings.shortcutTask': 'Yeni görev',
    'settings.shortcutDistraction': 'Dikkat notu',
    'settings.shortcutInterruption': 'Kesinti',
    'settings.shortcutProject': 'Proje seç',
    'settings.shortcutTaskSelect': 'Görev seç',
    'settings.shortcutMixer': 'Ses mikseri',
    'settings.data': 'Pomofree verilerin',
    'settings.dataDescription': 'Projelerini, görevlerini ve odak seanslarını CSV veya JSON olarak indirebilirsin.',
    'settings.deleteAccount': 'Hesabı ve verileri sil',
    'settings.deleteAccountConfirm': 'Pomofree hesabın ve içindeki görev, proje ve seanslar kalıcı olarak silinsin mi?',
    'settings.deleteAccountError': 'Hesap silinemedi. Güvenlik nedeniyle yeniden giriş yapıp tekrar denemen gerekebilir.',
    'settings.exportError': 'Pomofree verilerin indirilemedi. Lütfen tekrar dene.',
    'notifications.sessionEnded': 'Odak seansın tamamlandı.',
    'notifications.breakEnded': 'Mola bitti; yeniden odaklanmaya hazırsın.',
    'notifications.breakEndingSoon': 'Molan 30 saniye içinde bitecek.',
    'notifications.longBreakTime': 'Dört seansı tamamladın; uzun mola zamanı.',
    'notifications.roomStarted': 'Ortak çalışma odan hazır.',
    'notifications.participantJoined': 'Ortak çalışma odana yeni bir katılımcı geldi.',
    
    // Themes
    'themes.selectTheme': 'Tema Seç',
    'themes.whimsy_core': 'ÖZEL (Cottagecore)',
    'themes.frutiger_aero': 'ÖZEL (Frutiger Aero)',
    'themes.wired': 'ÖZEL (Wired)',
    'themes.synthwave': 'ÖZEL (Synthwave)',
    'themes.dark_academia': 'ÖZEL (Dark Academia)',
    'themes.gothic_core': 'ÖZEL (Gothic Core)',
    'themes.default_blue': 'Varsayılan Mavi',
    'themes.forest_green': 'Orman Yeşili',
    'themes.sunset': 'Gün Batımı',
    'themes.ocean': 'Okyanus',
    'themes.lavender': 'Lavanta',
    'themes.coffee': 'Kahve',
    'themes.matrix': 'Matrix',
    'themes.rose_dust': 'Gül Tozu',
    'themes.default': 'Varsayılan',
    'themes.forest': 'Orman',
    'themes.rose': 'Gül',
    'themes.slate': 'Slate',
    'themes.sand': 'Kum',
    'themes.dark_grey': 'Koyu Gri',
    
    // Login Modal
    'login.title': 'Giriş Yap',
    'login.register': 'Kayıt Ol',
    'login.email': 'E-posta',
    'login.emailPlaceholder': 'E-posta adresiniz',
    'login.password': 'Şifre',
    'login.passwordPlaceholder': 'Şifre',
    'login.username': 'Kullanıcı Adı',
    'login.usernamePlaceholder': 'Görünecek adınız',
    'login.loginButton': 'Giriş Yap',
    'login.registerButton': 'Kayıt Ol',
    'login.googleLogin': 'Google ile Giriş Yap',
    'login.twitterLogin': 'Twitter ile Giriş Yap',
    
    // Auth Errors
    'auth.popupBlocked': 'Popup engellendi! Lütfen tarayıcınızın popup engelleyicisini kapatın ve tekrar deneyin.',
    'auth.accountExists': 'Bu e-posta adresiyle zaten Google ile giriş yapmışsınız. Hesapları bağlamak ister misiniz?',
    'auth.linkError': 'Hesapları bağlarken hata oluştu: ',
    'auth.twitterLoginError': 'Twitter ile giriş yapılamadı: ',
    'auth.emailInUse': 'Bu e-posta adresiyle zaten bir Pomofree hesabı var.',
    'auth.invalidCredentials': 'E-posta veya şifre doğru değil.',
    'auth.invalidEmail': 'Geçerli bir e-posta adresi gir.',
    'auth.weakPassword': 'Daha güçlü bir şifre seç.',
    'auth.tooManyRequests': 'Çok fazla deneme yapıldı. Biraz bekleyip tekrar dene.',
    'auth.popupClosed': 'Giriş penceresi tamamlanmadan kapatıldı.',
    'auth.genericError': 'İşlem tamamlanamadı. Lütfen tekrar dene.',
    'auth.loadingData': 'Verilerini getiriyorum. Bir saniye; görevlerin ve istatistiklerin yerinde.',
    'auth.dataError': 'Verilerin yerinde ama bağlantı naz yaptı. Bir daha deneyelim.',
    'login.or': 'veya',
    'login.alreadyHaveAccount': 'Zaten hesabınız var mı? Giriş yapın',
    'login.noAccount': 'Hesabınız yok mu? Kayıt olun',
    
    // Report Modal
    'report.title': 'Rapor',
    'report.completedPomodoros': 'Tamamlanan Pomodoro sayısı:',
    'report.close': 'Kapat',
    'report.advancedTitle': 'GELİŞMİŞ RAPORLAR',
    'report.exportCSV': 'CSV İndir',
    'report.loading': 'Rapor yükleniyor...',
    'reports.exportCSV': 'CSV İndir',
    'reports.close': 'Kapat',
    'reports.loading': 'Rapor yükleniyor...',
    'report.thisWeek': 'Bu Hafta',
    'report.thisMonth': 'Bu Ay',
    'report.thisYear': 'Bu Yıl',
    'reports.thisWeek': 'Bu Hafta',
    'reports.thisMonth': 'Bu Ay',
    'reports.thisYear': 'Bu Yıl',
    'report.chartTitle': 'Verimlilik Analizi',
    'report.focusTime': 'Odaklanma Süresi (dk)',
    'report.pomodoros': 'Pomodorolar',
    'report.productivity': 'Verimlilik (%)',
    'reports.focusTime': 'Odaklanma Süresi (dk)',
    'reports.pomodoros': 'Pomodorolar',
    'reports.productivity': 'Verimlilik (%)',
    'report.dailyTrend': 'Günlük Trend',
    'report.projectDistribution': 'Proje Dağılımı',
    'report.productivityTrend': 'Verimlilik Trendi',
    'report.bestHours': 'En Verimli Saatler',
    'report.streakStats': 'Seri İstatistikleri',
    'reports.dailyTrend': 'Günlük Trend',
    'reports.projectDistribution': 'Proje Dağılımı',
    'reports.productivityTrend': 'Verimlilik Trendi',
    'reports.bestHours': 'En Verimli Saatler',
    'reports.streakStats': 'Seri İstatistikleri',
    'report.totalFocusTime': 'Toplam Odaklanma',
    'report.currentStreak': 'Mevcut Seri',
    'report.longestStreak': 'En Uzun Seri',
    'report.totalStreaks': 'Toplam Seri',
    'report.averageSession': 'Ortalama Oturum',
    'report.days': 'gün',
    'reports.totalFocusTime': 'Toplam Odaklanma',
    'reports.completedPomodoros': 'Tamamlanan Pomodorolar',
    'reports.currentStreak': 'Mevcut Seri',
    'reports.longestStreak': 'En Uzun Seri',
    'reports.totalStreaks': 'Toplam Seri',
    'reports.averageSession': 'Ortalama Oturum',
    'reports.days': 'gün',
    'reports.exportJSON': 'JSON İndir',
    'reports.period': 'Rapor dönemi',
    'reports.projectFilter': 'Proje filtresi',
    'reports.taskFilter': 'Görev filtresi',
    'reports.typeFilter': 'Seans türü filtresi',
    'reports.allProjects': 'Tüm projeler',
    'reports.allTasks': 'Tüm görevler',
    'reports.allTypes': 'Tüm seanslar',
    'reports.social': 'Birlikte çalışma',
    'reports.successRate': 'Seans başarısı',
    'reports.estimateAccuracy': 'Tahmin doğruluğu',
    'reports.socialSessions': 'Sosyal seans',
    'reports.completedTasks': 'Tamamlanan görev',
    'reports.abandonedSessions': 'Yarım bırakılan seans',
    'reports.focusScore': 'Ortalama odak puanı',
    'reports.sample': 'Dayanak seans sayısı',
    'reports.bestHourEvidence': 'En başarılı saat',
    'reports.bestDuration': 'En başarılı süre',
    'reports.fatigueOrder': 'Odak düşüşü görülen ortalama seans sırası',
    'reports.dayNight': 'Gündüz / gece başarı',
    'reports.socialSolo': 'Sosyal / bireysel başarı',
    'reports.sessionOrder': 'Seans sırasına göre başarı',
    'reports.insightTitle': 'Bu dönem için öneri',
    'reports.insight.insufficient': 'Kişisel öneri için birkaç seans daha tamamla.',
    'reports.insight.shorter': 'Tamamlama oranını artırmak için daha kısa odak seansını dene.',
    'reports.insight.interruptions': 'En sık kesinti kaynağını bir sonraki seanstan önce kapat.',
    'reports.insight.steady': 'Ritmin dengeli görünüyor; aynı saat aralığını koru.',
    'reports.topInterruption': 'En sık kesinti',
    'reports.interruptions': 'Kesinti analizi',
    'reports.noInterruptions': 'Bu dönemde kayıtlı kesinti yok.',
    'reports.noData': 'Bu filtrelerde henüz odak verisi yok.',
    'reports.noProjectData': 'Bu filtrelerde proje verisi yok.',
    'focus.shortStart': 'Kısa başlangıç',
    
    // Weekly Stats
    'stats.weeklyFocus': 'Haftalık Odaklanma',
    'stats.hours': 'saat',
    'stats.minutes': 'dakika',
    'stats.less': 'dan az',
    'stats.thisWeek': 'Bu hafta',
    'stats.today': 'Bugün',
    'stats.focusSummary': 'Odaklanma özeti',
    'stats.focused': 'odaklandın',
    
    // Celebration
    'celebration.title': 'Tebrikler!',
    'celebration.message': 'Pomodoro tamamlandı!',
    'celebration.continue': 'Devam Et',
    'celebration.birdCalling': 'Darlangıç kuşu çağırıyor...',
    
    // Project Showcase
    'showcase.title': 'Tamamlanan Projeler',
    'showcase.clear': 'Temizle',
    'showcase.clearConfirm': 'Emin misiniz? Biten tüm projeler kalıcı olarak silinecek.',
    'showcase.noProjects': 'Henüz tamamlanmış proje yok.',
    
    // General
    'general.appName': 'Pomofree',
    'general.tagline': 'Ücretsiz Pomodoro Zamanlayıcı',
    'general.loginRequired': 'Bu özellikleri kullanabilmek için giriş yapmalısınız!',
    
    // Achievements
    'achievements.newAchievement': 'Yeni Başarı!',
    'achievements.firstPomodoro': 'İlk Pomodoro',
    'achievements.firstPomodoroDesc': 'İlk pomodoro seansını tamamla',
    'achievements.pomodoroMaster': 'Pomodoro Ustası',
    'achievements.pomodoroMasterDesc': '5 pomodoro seansı tamamla',
    'achievements.pomodoroChampion': 'Pomodoro Şampiyonu',
    'achievements.pomodoroChampionDesc': '10 pomodoro seansı tamamla',
    'achievements.pomodoroLegend': 'Pomodoro Efsanesi',
    'achievements.pomodoroLegendDesc': '25 pomodoro seansı tamamla',
    'achievements.pomodoroGod': 'Pomodoro Tanrısı',
    'achievements.pomodoroGodDesc': '50 pomodoro seansı tamamla',
    'achievements.focusBeginner': 'Odaklanma Başlangıcı',
    'achievements.focusBeginnerDesc': '1 saat odaklanma süresi',
    'achievements.focusMaster': 'Odaklanma Ustası',
    'achievements.focusMasterDesc': '5 saat odaklanma süresi',
    'achievements.focusChampion': 'Odaklanma Şampiyonu',
    'achievements.focusChampionDesc': '10 saat odaklanma süresi',
    'achievements.focusLegend': 'Odaklanma Efsanesi',
    'achievements.focusLegendDesc': '20 saat odaklanma süresi',
    'achievements.streak3': '3 Günlük Seri',
    'achievements.streak3Desc': '3 gün üst üste pomodoro yap',
    'achievements.streak7': 'Haftalık Seri',
    'achievements.streak7Desc': '7 gün üst üste pomodoro yap',
    'achievements.streak30': 'Aylık Seri',
    'achievements.streak30Desc': '30 gün üst üste pomodoro yap',
    'achievements.socialFirst': 'Birlikte Daha Kolay',
    'achievements.socialFirstDesc': 'İlk ortak odak seansını tamamla',
    'achievements.socialTen': 'Odak Ekibi',
    'achievements.socialTenDesc': '10 ortak odak seansını tamamla',
    'general.defaultProject': 'Genel',
    'general.breakFinished': 'Mola bitti!',
    'general.enterUsername': 'Lütfen bir kullanıcı adı girin.',
    'general.cannotCompleteLastProject': 'Tek kalan aktif projeyi bitiremezsiniz.',
    'general.cannotDeleteLastProject': 'Son kalan aktif projeyi silemezsiniz.',
    'general.deleteProjectConfirm': 'Bu projeyi ve içindeki TÜM görevleri kalıcı olarak silmek istediğinizden emin misiniz?',
    'general.clearShowcaseConfirm': 'Emin misiniz? Biten tüm projeler kalıcı olarak silinecek.',
    
    // Language Selector
    'language.turkish': 'Türkçe',
    'language.english': 'English',
    
    // Dashboard
    'dashboard.title': 'Verimlilik Panosu',
    'dashboard.loading': 'Pano yükleniyor...',
    'dashboard.today': 'Bugün',
    'dashboard.yesterday': 'Dün',
    'dashboard.thisWeek': 'Bu Hafta',
    'dashboard.close': 'Kapat',
    'dashboard.focusTime': 'Odaklanma Süresi',
    'dashboard.pomodoros': 'Pomodorolar',
    'dashboard.tasks': 'Görevler',
    'dashboard.efficiency': 'Verimlilik',
    'dashboard.completed': 'Tamamlandı',
    'dashboard.average': 'Ortalama',
    'dashboard.goalProgress': 'Hedef İlerlemesi',
    'dashboard.achievements': 'Başarılar',
    'dashboard.insights': 'İçgörüler',
    'dashboard.goals': 'Hedefler',
    'dashboard.dailyGoal': 'Günlük Hedef',
    'dashboard.weeklyGoal': 'Haftalık Hedef',
    'dashboard.achievements.firstPomodoro': 'İlk Pomodoro',
    'dashboard.achievements.weekStreak': '1 Hafta Seri',
    'dashboard.achievements.hundredPomodoros': '100 Pomodoro',
    'dashboard.achievements.monthStreak': '1 Ay Seri',
    'dashboard.insights.bestDay': 'En verimli gününüz Pazartesi!',
    'dashboard.insights.consistentTime': 'En verimli saatleriniz 09:00-11:00.',
    'dashboard.insights.breakReminder': 'Düzenli molalar verimliliğinizi artırır.',

    // Study Room
    'studyRoom.studyWithMe': 'BENİMLE ÇALIŞ',
    'studyRoom.createRoom': 'Oda Oluştur',
    'studyRoom.joinRoom': 'Odaya Katıl',
    'studyRoom.roomName': 'Oda Adı',
    'studyRoom.roomNamePlaceholder': 'Çalışma odamız',
    'studyRoom.capacity': 'Kapasite',
    'studyRoom.people': 'kişi',
    'studyRoom.passwordProtected': 'Şifre korumalı',
    'studyRoom.roomType': 'Oda türü',
    'studyRoom.privateRoom': 'Özel oda',
    'studyRoom.anonymousRoom': 'Anonim açık oda',
    'studyRoom.privateDescription': 'Davet kodunu paylaştığın kişiler katılır.',
    'studyRoom.anonymousDescription': 'Kimliğin ve görev ayrıntıların gizlenir.',
    'studyRoom.quickAnonymous': 'Uygun anonim odaya katıl',
    'studyRoom.openFocusName': 'Açık Odak Odası',
    'studyRoom.hideTaskDetails': 'Görev ayrıntılarımı diğer katılımcılardan gizle',
    'studyRoom.breakChatOnly': 'Sohbeti yalnızca molalarda aç',
    'studyRoom.password': 'Şifre',
    'studyRoom.passwordPlaceholder': 'Oda şifresi',
    'studyRoom.optional': 'isteğe bağlı',
    'studyRoom.roomId': 'Oda ID',
    'studyRoom.roomIdPlaceholder': 'ABCD1234',
    'studyRoom.enterRoomName': 'Lütfen oda adı girin',
    'studyRoom.enterPassword': 'Lütfen en az 6 karakterli bir şifre girin',
    'studyRoom.enterRoomId': 'Lütfen oda ID girin',
    'studyRoom.roomCreated': 'Oda başarıyla oluşturuldu!',
    'studyRoom.shareLink': 'Paylaşım linki',
    'studyRoom.camera': 'Kamera',
    'studyRoom.cameraOff': 'Kamera Kapalı',
    'studyRoom.muteMic': 'Mikrofonu Kapat',
    'studyRoom.unmuteMic': 'Mikrofonu Aç',
    'studyRoom.turnOffCamera': 'Kamerayı Kapat',
    'studyRoom.turnOnCamera': 'Kamerayı Aç',
    'header.leaveRoom': 'Odadan Çık',
    'room.roomId': 'Oda ID',
    'room.participants': 'Katılımcılar',
    'studyRoom.leaveRoomConfirm': 'Odadan ayrılmak istediğinizden emin misiniz?',
    'studyRoom.settings': 'Ayarlar',
    'studyRoom.minimize': 'Küçült',
    'studyRoom.maximize': 'Büyült',
    'studyRoom.deviceSettings': 'Cihaz Ayarları',
    'studyRoom.typeMessage': 'Mesaj yazın...',
    'studyRoom.chatLocked': 'Odak seansı sürerken sohbet kapalı',
    'studyRoom.status.preparing': 'Hazırlanıyor',
    'studyRoom.status.focusing': 'Odaklanıyor',
    'studyRoom.status.break': 'Molada',
    'studyRoom.status.paused': 'Duraklatıldı',
    'studyRoom.microphoneError': 'Mikrofon erişimi reddedildi',
    'studyRoom.cameraError': 'Kamera erişimi reddedildi',
    'studyRoom.copyLink': 'Oda Linkini Kopyala',
    'studyRoom.linkCopied': 'Oda linki kopyalandı!',
    'timer.running': 'Çalışıyor',
    'timer.paused': 'Duraklatıldı',
    
    // Audio Controls
    'audio.startAudio': 'Sesli Sohbeti Aç',
    'audio.stopAudio': 'Sesli Sohbeti Kapat',
    'audio.mute': 'Sesi Kapat',
    'audio.unmute': 'Sesi Aç',
    'audio.connecting': 'Bağlanıyor...',
    'audio.connected': 'Sesli sohbet aktif',
    'audio.disconnected': 'Sesli sohbet kapalı',
    'audio.error': 'Mikrofon erişimi reddedildi veya mevcut değil',
    'audio.retry': 'Tekrar Dene',
    'audio.participants': 'Katılımcılar',
    
    // Patreon Support
    'patreon.title': 'Projeyi Destekle',
    'patreon.description': 'Bu proje sadece desteklerinizle hayatta kalabilir!',
    'patreon.supportButton': 'Destekle ($)',
    'patreon.buttonTitle': 'Patreon sayfamıza git',
    'patreon.close': 'Kapat',
    'patreon.kreosusButton': 'Kreosus (₺) ile Destekle',
    'patreon.kreosusTitle': 'Kreosus sayfamıza git',
    
    // Music Player
    'musicPlayer.title': 'Müzik Çalar',
    'musicPlayer.playlist': 'Çalma Listesi',
    'musicPlayer.pasteUrl': 'YouTube URL yapıştır...',
    'musicPlayer.play': 'Çal',
    'musicPlayer.previous': 'Önceki',
    'musicPlayer.next': 'Sonraki',
    'musicPlayer.pause': 'Duraklat',
    'musicPlayer.playButton': 'Çal',
    'musicPlayer.minimize': 'Küçült',
    'musicPlayer.restore': 'Geri Yükle',
    'musicPlayer.close': 'Kapat',
    
    // Room
    'room.joining': 'Odaya katılınıyor...',
    
    // General
    'general.close': 'Kapat',
    'general.back': 'Geri',
    
    // Legal
    'legal.terms': 'Kullanım Şartları',
    'legal.privacy': 'Gizlilik Politikası',
    'legal.termsTitle': 'Kullanım Şartları',
    'legal.privacyTitle': 'Gizlilik Politikası',
    'legal.lastUpdated': 'Son güncelleme:',
    
    // Footer
    'footer.support': 'Patreon ($) ile Destekle',
    'footer.show': 'Alt bilgiyi göster',
    'footer.hide': 'Alt bilgiyi gizle',
    'footer.kreosus': 'Kreosus (₺) ile Destekle',
    
    // Support Modal
    'support.title': 'Pomofree\'yi Destekle',
    'support.subtitle': 'Daha iyi bir Pomofree için desteğine ihtiyacımız var!',
    'support.body1': 'Kreosus (₺) veya Patreon ($) üzerinden yapacağın desteklerle uygulamayı daha gelişmiş hale getirebilir, yeni özellikler ekleyebilir ve mobil uygulamalarını geliştirebiliriz.',
    'support.body2': 'Destekçilere özel ayrıcalıklar: özel isteklerde bulunma, öncelikli geri bildirim, hatta tamamen sana özel bir tema "sipariş" edebilme!',
    'support.patreon': 'Patreon ile Destekle',
    'support.kreosus': 'Kreosus ile Destekle',
    'support.notToday': 'Bugünlük kapat',
    
    'legal.acceptance': '1. Şartların Kabulü',
    'legal.acceptanceText': 'Pomofree\'yi kullanarak bu sözleşmenin şart ve hükümlerini kabul etmiş ve bunlara bağlı kalmayı taahhüt etmiş olursunuz. Yukarıdakileri kabul etmiyorsanız, lütfen bu hizmeti kullanmayın.',
    'legal.description': '2. Hizmet Açıklaması',
    'legal.descriptionText': 'Pomofree, kullanıcıların odaklanma seansları ve molalar aracılığıyla verimliliklerini yönetmelerine yardımcı olan bir Pomodoro zamanlayıcı uygulamasıdır. Hizmet, zamanlayıcı işlevselliği, görev yönetimi, ilerleme takibi ve çalışma odası özelliklerini içerir.',
    'legal.userAccounts': '3. Kullanıcı Hesapları',
    'legal.userAccountsText': 'Hizmetin belirli özelliklerine erişmek için bir hesap oluşturmanız gerekebilir. Hesap bilgilerinizin gizliliğini korumaktan ve hesabınız altında gerçekleşen tüm faaliyetlerden sorumlusunuz.',
    'legal.acceptableUse': '4. Kabul Edilebilir Kullanım',
    'legal.acceptableUseText': 'Hizmeti yalnızca yasal amaçlarla ve bu şartlara uygun olarak kullanmayı kabul edersiniz. Şunları yapamazsınız:',
    'legal.useRestriction1': 'Hizmeti geçerli yasaları veya düzenlemeleri ihlal edecek şekilde kullanmak',
    'legal.useRestriction2': 'Hizmetin herhangi bir bölümüne yetkisiz erişim sağlamaya çalışmak',
    'legal.useRestriction3': 'Hizmeti veya hizmete bağlı sunucuları bozmak veya kesintiye uğratmak',
    'legal.useRestriction4': 'Hizmeti zararlı veya kötü amaçlı kod iletmek için kullanmak',
    'legal.termsPrivacy': 'Gizlilik',
    'legal.privacyText': 'Gizliliğiniz bizim için önemlidir. Lütfen hizmetinizi kullanımınızı da yöneten Gizlilik Politikamızı inceleyin.',
    'legal.disclaimer': '6. Garanti Reddi',
    'legal.disclaimerText': 'Hizmet "olduğu gibi" ve "mevcut olduğu şekilde" sağlanmaktadır. Açık veya zımni hiçbir garanti vermiyoruz ve ticari satılabilirlik, belirli bir amaca uygunluk veya fikri mülkiyet ihlali dahil olmak üzere diğer tüm garantileri reddediyoruz.',
    'legal.limitation': '7. Sorumluluk Sınırlaması',
    'legal.limitationText': 'Hiçbir durumda Pomofree veya tedarikçileri, hizmeti kullanma veya kullanamama nedeniyle ortaya çıkan herhangi bir zarardan (veri veya kar kaybı zararları veya iş kesintisi dahil) sorumlu olmayacaktır.',
    'legal.termsChanges': '8. Şartlardaki Değişiklikler',
    'legal.termsChangesText': 'Bu şartları istediğimiz zaman değiştirme hakkını saklı tutarız. Yeni şartları bu sayfada yayınlayarak kullanıcılara önemli değişiklikleri bildireceğiz. Bu tür değişikliklerden sonra hizmeti kullanmaya devam etmeniz yeni şartları kabul ettiğiniz anlamına gelir.',
    'legal.contact': '9. İletişim Bilgileri',
    'legal.contactText': 'Bu Kullanım Şartları hakkında sorularınız varsa, lütfen destek kanallarımız aracılığıyla bizimle iletişime geçin.',
    'legal.introduction': '1. Giriş',
    'legal.introductionText': 'Bu Gizlilik Politikası, Pomofree hizmetimizi kullandığınızda bilgilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklar. Gizliliğinizi korumaya ve kişisel verilerinizin güvenliğini sağlamaya kararlıyız.',
    'legal.informationWeCollect': '2. Topladığımız Bilgiler',
    'legal.personalInfo': 'Kişisel Bilgiler',
    'legal.personalInfoText': 'Hesap oluşturduğunuzda şunları toplayabiliriz:',
    'legal.collect1': 'E-posta adresi',
    'legal.collect2': 'Kullanıcı adı veya görünen ad',
    'legal.collect3': 'Sağlamayı seçtiğiniz profil bilgileri',
    'legal.usageInfo': 'Kullanım Bilgileri',
    'legal.usageInfoText': 'Hizmetin kullanımı hakkında belirli bilgileri otomatik olarak toplarız:',
    'legal.usage1': 'Zamanlayıcı seansları ve verimlilik verileri',
    'legal.usage2': 'Oluşturduğunuz görevler ve projeler',
    'legal.usage3': 'Ayarlar ve tercihler',
    'legal.usage4': 'Cihaz bilgileri ve tarayıcı türü',
    'legal.howWeUse': '3. Bilgilerinizi Nasıl Kullandığımız',
    'legal.howWeUseText': 'Topladığımız bilgileri şunlar için kullanırız:',
    'legal.use1': 'Hizmeti sağlamak ve sürdürmek',
    'legal.use2': 'Hesabınızı işlemek ve verilerinizi yönetmek',
    'legal.use3': 'Verimlilik raporları ve istatistikleri oluşturmak',
    'legal.use4': 'Hizmetimizi geliştirmek ve yeni özellikler geliştirmek',
    'legal.use5': 'Hizmet hakkında sizinle iletişim kurmak',
    'legal.dataStorage': '4. Veri Depolama ve Güvenlik',
    'legal.dataStorageText': 'Verileriniz Pomofree hesabınızda endüstri standardı şifreleme ve güvenlik önlemleriyle saklanır.',
    'legal.dataSharing': '5. Bilgi Paylaşımı',
    'legal.dataSharingText': 'Rızanız olmadan kişisel bilgilerinizi üçüncü taraflara satmaz, takas etmez veya başka şekilde devretmeyiz, şunlar hariç:',
    'legal.share1': 'Yasa veya yasal süreç gerektirdiğinde',
    'legal.share2': 'Haklarımızı veya kullanıcılarımızın güvenliğini korumak için',
    'legal.share3': 'Hizmetimizi işletmemize yardımcı olan hizmet sağlayıcıları ile (katı gizlilik anlaşmaları altında)',
    'legal.cookies': '6. Çerezler ve İzleme',
    'legal.cookiesText': 'Deneyiminizi geliştirmek, tercihlerinizi hatırlamak ve kullanım kalıplarını analiz etmek için çerezler ve benzer izleme teknolojileri kullanabiliriz.',
    'legal.yourRights': '7. Haklarınız',
    'legal.yourRightsText': 'Şu haklara sahipsiniz:',
    'legal.rights1': 'Kişisel verilerinize erişim',
    'legal.rights2': 'Yanlış bilgileri düzeltme',
    'legal.rights3': 'Hesabınızı ve verilerinizi silme',
    'legal.rights4': 'Verilerinizi dışa aktarma',
    'legal.rights5': 'Belirli veri işleme faaliyetlerinden vazgeçme',
    'legal.dataRetention': '8. Veri Saklama',
    'legal.dataRetentionText': 'Hesabınız aktif olduğu sürece veya hizmetimizi size sağlamak için gerekli olduğu sürece kişisel bilgilerinizi saklarız.',
    'legal.children': '9. Çocukların Gizliliği',
    'legal.childrenText': 'Hizmetimiz 13 yaşın altındaki çocuklar için tasarlanmamıştır. 13 yaşın altındaki çocuklardan bilerek kişisel bilgi toplamayız.',
    'legal.privacyChanges': '10. Bu Politikadaki Değişiklikler',
    'legal.privacyChangesText': 'Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Yeni Gizlilik Politikasını bu sayfada yayınlayarak ve "Son güncelleme" tarihini güncelleyerek değişiklikleri size bildireceğiz.'
  },
  en: {
    // Header
    'header.themes': 'Themes',
    'header.todo': 'Todo',
    'header.social': 'Social',
    'header.home': 'Home',
    'header.dashboard': 'Dashboard',
    'header.advancedReports': 'Advanced Reports',
    'header.report': 'Report',
    'header.settings': 'Settings',
    'header.login': 'Login',
    'header.logout': 'Logout',
    'header.profilePhoto': 'profile photo',

    // Domain notice
    'domainNotice.label': 'New address announcement',
    'domainNotice.title': 'We moved. Boxes sorted, cat safe and sound.',
    'domainNotice.newAddress': 'Our new home is',
    'domainNotice.countdown': 'The old address closes in {days} days; update your bookmark now so nobody blames the cat later.',
    'domainNotice.close': 'Dismiss announcement',
    
    // Timer
    'timer.pomodoro': 'Pomodoro',
    'timer.shortBreak': 'Short Break',
    'timer.longBreak': 'Long Break',
    'timer.start': 'START',
    'timer.stop': 'STOP',
    'timer.sessionGoal': 'What will be completed by the end of this session?',
    'timer.sessionGoalPlaceholder': 'Write one concrete outcome...',
    'timer.noGoal': 'No goal was set for this session',
    'timer.emergencyStart': 'Just start for 5 minutes',
    'timer.adaptiveTitle': 'A duration that may suit you',
    'timer.sessionsBased': 'sessions',
    'timer.completion': 'completion',
    'timer.try': 'try',
    'timer.notNow': 'Not now',
    'timer.averageDuration': 'Average',
    'timer.scope.general': 'Your general work rhythm',
    'timer.scope.project': 'Your rhythm in this project',
    'timer.scope.task': 'Your rhythm on this task',
    'timer.goalRequiredAlert': 'Write one concrete goal for this session before starting.',
    'timer.quickSettings': 'Timer settings',
    
    // Tasks
    'tasks.activeTasks': 'Active Tasks',
    'tasks.noTasks': 'No tasks for this project.',
    'tasks.addTask': 'Add new task...',
    'tasks.addProject': 'Create new project...',
    'tasks.addProjectButton': 'Add Project',
    'tasks.completeProject': 'Complete',
    'tasks.completeProjectTooltip': 'Complete all tasks first to finish the project.',
    'tasks.completeProjectTooltip2': 'Complete the project and move to showcase.',
    'tasks.deleteProjectTooltip': 'Cannot delete the last remaining project.',
    'tasks.deleteProjectTooltip2': 'Delete project and all its tasks.',
    'tasks.pomodoro': 'Pomodoro',
    'tasks.minutes': 'min',
    'tasks.estimate': 'Estimate',
    'tasks.remaining': 'left',

    // Todo
    'todo.title': 'Todo',
    'todo.subtitle': 'Plan your tasks, focus, and make progress.',
    'todo.search': 'Search tasks',
    'todo.myDay': 'My Day',
    'todo.important': 'Important',
    'todo.planned': 'Planned',
    'todo.all': 'All tasks',
    'todo.completed': 'Completed',
    'todo.lists': 'Lists',
    'todo.newList': 'New list',
    'todo.addList': 'Add list',
    'todo.listView': 'List',
    'todo.boardView': 'Board',
    'todo.addTask': 'Add task',
    'todo.addTaskPlaceholder': 'Write a new task...',
    'todo.details': 'Task details',
    'todo.taskName': 'Task name',
    'todo.note': 'Note',
    'todo.notePlaceholder': 'Add a note about this task...',
    'todo.dueDate': 'Due date',
    'todo.list': 'List',
    'todo.addToMyDay': 'Add to My Day',
    'todo.removeFromMyDay': 'Remove from My Day',
    'todo.sendToActiveTasks': 'Send to active tasks',
    'todo.inActiveTasks': 'In active tasks',
    'todo.markImportant': 'Mark as important',
    'todo.removeImportant': 'Remove importance',
    'todo.deleteTask': 'Delete task',
    'todo.deleteTaskConfirm': 'Permanently delete this task?',
    'todo.deleteList': 'Delete list',
    'todo.deleteListConfirm': 'Permanently delete this list and its tasks?',
    'todo.emptyTitle': 'Everything is done here',
    'todo.emptyText': 'Start by adding a new task.',
    'todo.noResults': 'No tasks match your search.',
    'todo.tasksCount': 'tasks',
    'todo.pomodoros': 'pomodoros completed',
    'todo.loading': 'Preparing your Todo workspace...',
    'todo.loadError': 'Todo data could not be loaded.',
    'todo.saveError': 'The change could not be saved.',
    'todo.listLimitError': 'This list has too many tasks to delete at once.',
    'todo.syncHint': 'Changes are saved to your Pomofree account.',
    'todo.closeDetails': 'Close details',
    'todo.estimate': 'Estimated Pomodoros',
    'todo.remaining': 'left',

    // Social
    'social.title': 'Social',
    'social.heroEyebrow': 'Pomofree community',
    'social.heroTitle': 'What is happening on Pomofree?',
    'social.heroText': 'Completed Pomofree focus sessions show up here. Leave a quick note or simply see how everyone is doing.',
    'social.liveData': 'Live data',
    'social.activePeople': 'registered users',
    'social.totalMinutes': 'minutes focused',
    'social.refresh': 'Refresh',
    'social.refreshing': 'Refreshing',
    'social.guestTitle': 'Sign in to see what is here',
    'social.guestText': 'The weekly list and posts are available to signed-in users.',
    'social.guestButton': 'Go to sign in',
    'social.guestSharePlaceholder': 'Sign in to share a note.',
    'social.weekLabel': 'Community summary',
    'social.myWeek': 'Your totals',
    'social.focusTime': 'Focus time',
    'social.completedSessions': 'Completed sessions',
    'social.activeDays': 'Active days',
    'social.noPersonalStats': 'You have not completed a session yet.',
    'social.leadersTitle': 'All-time list',
    'social.leadersText': 'Based on Pomofree sessions completed so far.',
    'social.focusChampions': 'Time',
    'social.finishers': 'Sessions',
    'social.versatile': 'Projects',
    'social.minutes': 'min',
    'social.sessions': 'sessions',
    'social.projects': 'projects',
    'social.days': 'days',
    'social.emptyLeaders': 'The list will fill after the first completed session.',
    'social.communityEyebrow': 'Shared space',
    'social.communityTitle': 'Progress grows when it is shared.',
    'social.communityText': 'Celebrate a win, ask about a blocker, or leave someone a little support.',
    'social.syncHint': 'Your focus summary is shared; your name and photo appear only with your permission.',
    'social.feedEyebrow': 'Community feed',
    'social.feedTitle': 'Feed',
    'social.feedText': 'What did you do, and where did you get stuck? Keep it short.',
    'social.sharePlaceholder': 'How is today going?',
    'social.mood': 'Note type',
    'social.mood.progress': 'Making progress',
    'social.mood.victory': 'Done',
    'social.mood.question': 'I have a question',
    'social.mood.break': 'Taking a break',
    'social.share': 'Share',
    'social.emptyFeed': 'No one has posted yet. You can leave the first note.',
    'social.reaction.support': 'With you',
    'social.reaction.spark': 'Nice one',
    'social.reaction.focus': 'Keep going',
    'social.comments': 'Comments',
    'social.hideComments': 'Hide comments',
    'social.noComments': 'No comments yet.',
    'social.commentPlaceholder': 'Write something',
    'social.commentSubmit': 'Send',
    'social.delete': 'Delete',
    'social.deleteConfirm': 'Are you sure you want to delete this note?',
    'social.now': 'Now',
    'social.loading': 'Opening the social area...',
    'social.loadError': 'The social area did not open. Try again in a moment.',
    'social.saveError': 'Could not save that. You can try once more.',
    'social.settings': 'Social settings',
    'social.settingsText': 'Choose how you appear to the community.',
    'social.publicProfile': 'Show my name and profile photo to everyone',
    'social.publicProfileHelp': 'When off, your name is masked like L** N**** and your photo stays hidden.',
    'project.settings': 'Project settings',
    'project.name': 'Project name',
    'project.description': 'Description',
    'project.target': 'Target Pomodoros',
    'project.dailyTarget': 'Daily target',
    'project.dueDate': 'Due date',
    'project.priority': 'Priority',
    'project.color': 'Color',
    'project.low': 'Low',
    'project.normal': 'Normal',
    'project.high': 'High',
    'project.archive': 'Archive project',
    'project.archiveConfirm': 'Archive this project? Its tasks will be preserved.',
    'project.completedPomodoros': 'completed',
    'project.remainingPomodoros': 'estimated remaining',
    'project.estimatedFinish': 'estimated finish',
    'project.deadlineRisk': 'deadline risk',
    'project.inactivePrefix': 'You have not started a session in this project for',
    'project.inactiveSuffix': 'days. Would you like to continue, edit, or archive it?',
    'project.review': 'Review project',

    // Focus flow
    'focus.tools': 'Focus tools',
    'focus.sessionActive': 'Focus session in progress',
    'focus.sessionReady': 'Focus workspace ready',
    'focus.notes': 'notes',
    'focus.interruptions': 'interruptions',
    'focus.thoughtParking': 'Thought Parking',
    'focus.interrupted': 'Interrupted',
    'focus.sounds': 'Focus Sounds',
    'focus.thoughtPrompt': 'Park the thought without stopping the timer',
    'focus.thoughtPlaceholder': 'Write down what you will revisit later...',
    'focus.save': 'Save',
    'focus.interruptionReason': 'What interrupted you?',
    'focus.optionalNote': 'Optional short note',
    'focus.phone': 'Phone',
    'focus.notification': 'Notification',
    'focus.person': 'Person',
    'focus.water': 'Restroom / water',
    'focus.otherTask': 'Another task',
    'focus.internal': 'Internal distraction',
    'focus.technical': 'Technical issue',
    'focus.other': 'Other',
    'focus.completeNote': 'Mark note as completed',
    'focus.toTask': 'Turn into task',
    'focus.deleteNote': 'Delete note',
    'focus.smartBreak': 'Smart break',
    'focus.break.water': 'Drink a glass of water.',
    'focus.break.stretch': 'Gently move your shoulders and neck.',
    'focus.break.eye': 'Look into the distance for 20 seconds and rest your eyes.',
    'focus.break.walk': 'Leave the desk, take a short walk, and move your shoulders.',
    'focus.break.plan': 'Choose one clear goal for the next session.',
    'focus.sessionComplete': 'Session complete',
    'focus.reviewTitle': 'How was this session?',
    'focus.result': 'Result',
    'focus.completed': 'Completed',
    'focus.partial': 'Partially completed',
    'focus.notCompleted': 'Not completed',
    'focus.distracted': 'Distracted',
    'focus.focusLevel': 'Focus',
    'focus.difficulty': 'Difficulty',
    'focus.energy': 'Energy',
    'focus.low': 'Low',
    'focus.normal': 'Normal',
    'focus.high': 'High',
    'focus.easy': 'Easy',
    'focus.hard': 'Hard',
    'focus.reviewNote': 'Short note (optional)',
    'focus.skip': 'Skip',
    'focus.saveReview': 'Save review',
    'focus.fiveDone': 'You completed five minutes. How should we continue?',
    'focus.continueTen': '10 more minutes',
    'focus.switchNormal': 'Normal Pomodoro',
    'focus.commandPalette': 'Command palette',
    'focus.commandSearch': 'Search for an action...',
    'focus.pauseAfterInterruption': 'Would you like to pause the timer?',
    'focus.reviewSaveError': 'The review could not be saved. Your session time is still stored in your Pomofree account.',
    'focusSound.title': 'Focus Sound Mixer',
    'focusSound.projectProfile': 'Saved automatically for this project',
    'focusSound.rain': 'Rain',
    'focusSound.cafe': 'Café',
    'focusSound.keyboard': 'Keyboard',
    'focusSound.train': 'Train',
    'focusSound.brown': 'Brown noise',
    'focusSound.white': 'White noise',
    'focusSound.fire': 'Fireplace',
    'focusSound.nature': 'Nature',
    'focusSound.focusLevel': 'Full during focus, lower on breaks',
    'focusSound.breakLevel': 'Break level (25%)',
    'focusSound.muteAll': 'Mute all',
    
    // Settings Modal
    'settings.title': 'Settings',
    'settings.pomodoro': 'Pomodoro Duration (minutes)',
    'settings.shortBreak': 'Short Break Duration (minutes)',
    'settings.longBreak': 'Long Break Duration (minutes)',
    'settings.save': 'Save',
    'settings.cancel': 'Cancel',
    'settings.timerSection': 'Timer',
    'settings.quickTimerTitle': 'Adjust timer',
    'settings.profileSection': 'Profile',
    'settings.profilePhotoUrl': 'Profile photo URL',
    'settings.profilePhotoUrlPlaceholder': 'https://example.com/photo.webp',
    'settings.uploadPhoto': 'Upload photo',
    'settings.removePhoto': 'Remove photo',
    'settings.profilePhotoHelp': 'Choose a JPG, PNG, or WebP. It is resized to 128×128 and compressed for Firestore.',
    'settings.profilePhotoError': 'Use an HTTPS URL or a JPG, PNG, or WebP under 5 MB.',
    'settings.socialSection': 'Social privacy',
    'settings.socialProfilePublic': 'Show my name and profile photo in Social',
    'settings.socialProfileHelp': 'When off, your name is masked and your profile photo stays private.',
    'settings.emergencyMinutes': 'Quick-start duration (3–10 minutes)',
    'settings.focusFlow': 'Focus flow',
    'settings.goalRequired': 'Require a session goal',
    'settings.notifications': 'Desktop notifications',
    'settings.notifySessionEnd': 'When a session ends',
    'settings.notifyBreakEnd': 'Break ending and return time',
    'settings.notifyLongBreak': 'Long break time',
    'settings.notifyRoomStarted': 'When a co-working room starts',
    'settings.notifyParticipantJoined': 'When someone joins the room',
    'settings.adaptive': 'Adaptive duration suggestions',
    'settings.adaptiveFrequency': 'Suggestion frequency',
    'settings.frequencyFrequent': 'At most once a day',
    'settings.frequencyBalanced': 'At most once every three days',
    'settings.frequencyRare': 'At most once a week',
    'settings.breakTips': 'Smart break suggestions',
    'settings.breakMovement': 'Movement suggestions',
    'settings.breakEyes': 'Eye-rest suggestions',
    'settings.breakHydration': 'Water reminders',
    'settings.breakPlanning': 'Plan the next session',
    'settings.interruptionAction': 'When an interruption is logged',
    'settings.keepRunning': 'Keep the timer running',
    'settings.autoPause': 'Pause automatically',
    'settings.askMe': 'Ask every time',
    'settings.accessibility': 'Accessibility',
    'settings.reducedMotion': 'Reduce motion',
    'settings.highContrast': 'High contrast',
    'settings.colorVision': 'Color vision support',
    'settings.colorDefault': 'Default',
    'settings.colorGreen': 'Green distinction support',
    'settings.colorRed': 'Red distinction support',
    'settings.colorBlue': 'Blue distinction support',
    'settings.shortcuts': 'Keyboard shortcuts',
    'settings.shortcutsEnabled': 'Shortcuts enabled',
    'settings.shortcutTask': 'New task',
    'settings.shortcutDistraction': 'Distraction note',
    'settings.shortcutInterruption': 'Interruption',
    'settings.shortcutProject': 'Select project',
    'settings.shortcutTaskSelect': 'Select task',
    'settings.shortcutMixer': 'Sound mixer',
    'settings.data': 'Your Pomofree data',
    'settings.dataDescription': 'Download your projects, tasks, and focus sessions as CSV or JSON.',
    'settings.deleteAccount': 'Delete account and data',
    'settings.deleteAccountConfirm': 'Permanently delete your Pomofree account, tasks, projects, and sessions?',
    'settings.deleteAccountError': 'The account could not be deleted. You may need to sign in again for security.',
    'settings.exportError': 'Your Pomofree data could not be downloaded. Please try again.',
    'notifications.sessionEnded': 'Your focus session is complete.',
    'notifications.breakEnded': 'Your break is over; you are ready to focus again.',
    'notifications.breakEndingSoon': 'Your break will end in 30 seconds.',
    'notifications.longBreakTime': 'You completed four sessions; it is time for a long break.',
    'notifications.roomStarted': 'Your co-working room is ready.',
    'notifications.participantJoined': 'A new participant joined your co-working room.',
    
    // Themes
    'themes.selectTheme': 'Select Theme',
    'themes.whimsy_core': 'SPECIAL (Cottagecore)',
    'themes.frutiger_aero': 'SPECIAL (Frutiger Aero)',
    'themes.wired': 'SPECIAL (Wired)',
    'themes.synthwave': 'SPECIAL (Synthwave)',
    'themes.dark_academia': 'SPECIAL (Dark Academia)',
    'themes.gothic_core': 'SPECIAL (Gothic Core)',
    'themes.default_blue': 'Default Blue',
    'themes.forest_green': 'Forest Green',
    'themes.sunset': 'Sunset',
    'themes.ocean': 'Ocean',
    'themes.lavender': 'Lavender',
    'themes.coffee': 'Coffee',
    'themes.matrix': 'Matrix',
    'themes.rose_dust': 'Rose Dust',
    'themes.default': 'Default',
    'themes.forest': 'Forest',
    'themes.rose': 'Rose',
    'themes.slate': 'Slate',
    'themes.sand': 'Sand',
    'themes.dark_grey': 'Dark Grey',
    
    // Login Modal
    'login.title': 'Login',
    'login.register': 'Register',
    'login.email': 'Email',
    'login.emailPlaceholder': 'Email address',
    'login.password': 'Password',
    'login.passwordPlaceholder': 'Password',
    'login.username': 'Username',
    'login.usernamePlaceholder': 'Your display name',
    'login.loginButton': 'Login',
    'login.registerButton': 'Register',
    'login.googleLogin': 'Sign in with Google',
    'login.twitterLogin': 'Sign in with Twitter',
    
    // Auth Errors
    'auth.popupBlocked': 'Popup blocked! Please disable your browser\'s popup blocker and try again.',
    'auth.accountExists': 'You already have an account with this email using Google. Would you like to link the accounts?',
    'auth.linkError': 'Error linking accounts: ',
    'auth.twitterLoginError': 'Could not sign in with Twitter: ',
    'auth.emailInUse': 'A Pomofree account already exists for this email address.',
    'auth.invalidCredentials': 'The email or password is incorrect.',
    'auth.invalidEmail': 'Enter a valid email address.',
    'auth.weakPassword': 'Choose a stronger password.',
    'auth.tooManyRequests': 'Too many attempts. Wait a moment and try again.',
    'auth.popupClosed': 'The sign-in window was closed before completion.',
    'auth.genericError': 'The action could not be completed. Please try again.',
    'auth.loadingData': 'Loading your data. Your tasks and stats are safe and will be here in a moment.',
    'auth.dataError': 'Your data is safe, but the connection stumbled. Let’s try that again.',
    'login.or': 'or',
    'login.alreadyHaveAccount': 'Already have an account? Sign in',
    'login.noAccount': 'Don\'t have an account? Sign up',
    
    // Report Modal
    'report.title': 'Report',
    'report.completedPomodoros': 'Completed Pomodoros:',
    'report.close': 'Close',
    'report.advancedTitle': 'ADVANCED REPORTS',
    'report.exportCSV': 'Export CSV',
    'report.loading': 'Loading reports...',
    'reports.exportCSV': 'Export CSV',
    'reports.close': 'Close',
    'reports.loading': 'Loading reports...',
    'report.thisWeek': 'This Week',
    'report.thisMonth': 'This Month',
    'report.thisYear': 'This Year',
    'reports.thisWeek': 'This Week',
    'reports.thisMonth': 'This Month',
    'reports.thisYear': 'This Year',
    'report.chartTitle': 'Productivity Analysis',
    'report.focusTime': 'Focus Time (min)',
    'report.pomodoros': 'Pomodoros',
    'report.productivity': 'Productivity (%)',
    'reports.focusTime': 'Focus Time (min)',
    'reports.pomodoros': 'Pomodoros',
    'reports.productivity': 'Productivity (%)',
    'report.dailyTrend': 'Daily Trend',
    'report.projectDistribution': 'Project Distribution',
    'report.productivityTrend': 'Productivity Trend',
    'report.bestHours': 'Best Hours',
    'report.streakStats': 'Streak Statistics',
    'reports.dailyTrend': 'Daily Trend',
    'reports.projectDistribution': 'Project Distribution',
    'reports.productivityTrend': 'Productivity Trend',
    'reports.bestHours': 'Best Hours',
    'reports.streakStats': 'Streak Statistics',
    'report.totalFocusTime': 'Total Focus Time',
    'report.currentStreak': 'Current Streak',
    'report.longestStreak': 'Longest Streak',
    'report.totalStreaks': 'Total Streaks',
    'report.averageSession': 'Average Session',
    'report.days': 'days',
    'reports.totalFocusTime': 'Total Focus Time',
    'reports.completedPomodoros': 'Completed Pomodoros',
    'reports.currentStreak': 'Current Streak',
    'reports.longestStreak': 'Longest Streak',
    'reports.totalStreaks': 'Total Streaks',
    'reports.averageSession': 'Average Session',
    'reports.days': 'days',
    'reports.exportJSON': 'Export JSON',
    'reports.period': 'Report period',
    'reports.projectFilter': 'Project filter',
    'reports.taskFilter': 'Task filter',
    'reports.typeFilter': 'Session type filter',
    'reports.allProjects': 'All projects',
    'reports.allTasks': 'All tasks',
    'reports.allTypes': 'All sessions',
    'reports.social': 'Co-working',
    'reports.successRate': 'Session success',
    'reports.estimateAccuracy': 'Estimate accuracy',
    'reports.socialSessions': 'Social sessions',
    'reports.completedTasks': 'Completed tasks',
    'reports.abandonedSessions': 'Abandoned sessions',
    'reports.focusScore': 'Average focus score',
    'reports.sample': 'Supporting session count',
    'reports.bestHourEvidence': 'Most successful hour',
    'reports.bestDuration': 'Most successful duration',
    'reports.fatigueOrder': 'Average session order where focus drops',
    'reports.dayNight': 'Day / night success',
    'reports.socialSolo': 'Social / solo success',
    'reports.sessionOrder': 'Success by session order',
    'reports.insightTitle': 'Suggestion for this period',
    'reports.insight.insufficient': 'Complete a few more sessions for a personal suggestion.',
    'reports.insight.shorter': 'Try a shorter focus session to improve your completion rate.',
    'reports.insight.interruptions': 'Remove your most frequent interruption before the next session.',
    'reports.insight.steady': 'Your rhythm looks steady; keep the same time window.',
    'reports.topInterruption': 'Top interruption',
    'reports.interruptions': 'Interruption analysis',
    'reports.noInterruptions': 'No interruptions were recorded in this period.',
    'reports.noData': 'There is no focus data for these filters yet.',
    'reports.noProjectData': 'There is no project data for these filters.',
    'focus.shortStart': 'Short start',
    
    // Weekly Stats
    'stats.weeklyFocus': 'Weekly Focus',
    'stats.hours': 'hours',
    'stats.minutes': 'minutes',
    'stats.less': 'less than',
    'stats.thisWeek': 'This week',
    'stats.today': 'Today',
    'stats.focusSummary': 'Focus summary',
    'stats.focused': 'focused',
    
    // Celebration
    'celebration.title': 'Congratulations!',
    'celebration.message': 'Pomodoro completed!',
    'celebration.continue': 'Continue',
    'celebration.birdCalling': 'Swallow bird is calling...',
    
    // Project Showcase
    'showcase.title': 'Completed Projects',
    'showcase.clear': 'Clear',
    'showcase.clearConfirm': 'Are you sure? All completed projects will be permanently deleted.',
    'showcase.noProjects': 'No completed projects yet.',
    
    // General
    'general.appName': 'Pomofree',
    'general.tagline': 'Free Pomodoro Timer',
    'general.loginRequired': 'You must login to use these features!',
    
    // Achievements
    'achievements.newAchievement': 'New Achievement!',
    'achievements.firstPomodoro': 'First Pomodoro',
    'achievements.firstPomodoroDesc': 'Complete your first pomodoro session',
    'achievements.pomodoroMaster': 'Pomodoro Master',
    'achievements.pomodoroMasterDesc': 'Complete 5 pomodoro sessions',
    'achievements.pomodoroChampion': 'Pomodoro Champion',
    'achievements.pomodoroChampionDesc': 'Complete 10 pomodoro sessions',
    'achievements.pomodoroLegend': 'Pomodoro Legend',
    'achievements.pomodoroLegendDesc': 'Complete 25 pomodoro sessions',
    'achievements.pomodoroGod': 'Pomodoro God',
    'achievements.pomodoroGodDesc': 'Complete 50 pomodoro sessions',
    'achievements.focusBeginner': 'Focus Beginner',
    'achievements.focusBeginnerDesc': '1 hour of focus time',
    'achievements.focusMaster': 'Focus Master',
    'achievements.focusMasterDesc': '5 hours of focus time',
    'achievements.focusChampion': 'Focus Champion',
    'achievements.focusChampionDesc': '10 hours of focus time',
    'achievements.focusLegend': 'Focus Legend',
    'achievements.focusLegendDesc': '20 hours of focus time',
    'achievements.streak3': '3 Day Streak',
    'achievements.streak3Desc': 'Do pomodoro for 3 consecutive days',
    'achievements.streak7': 'Weekly Streak',
    'achievements.streak7Desc': 'Do pomodoro for 7 consecutive days',
    'achievements.streak30': 'Monthly Streak',
    'achievements.streak30Desc': 'Do pomodoro for 30 consecutive days',
    'achievements.socialFirst': 'Better Together',
    'achievements.socialFirstDesc': 'Complete your first shared focus session',
    'achievements.socialTen': 'Focus Crew',
    'achievements.socialTenDesc': 'Complete 10 shared focus sessions',
    'general.defaultProject': 'General',
    'general.breakFinished': 'Break finished!',
    'general.enterUsername': 'Please enter a username.',
    'general.cannotCompleteLastProject': 'Cannot complete the last remaining active project.',
    'general.cannotDeleteLastProject': 'Cannot delete the last remaining active project.',
    'general.deleteProjectConfirm': 'Are you sure you want to permanently delete this project and ALL its tasks?',
    'general.clearShowcaseConfirm': 'Are you sure? All completed projects will be permanently deleted.',
    
    // Language Selector
    'language.turkish': 'Türkçe',
    'language.english': 'English',
    
    // Dashboard
    'dashboard.title': 'Productivity Dashboard',
    'dashboard.loading': 'Loading dashboard...',
    'dashboard.today': 'Today',
    'dashboard.yesterday': 'Yesterday',
    'dashboard.thisWeek': 'This Week',
    'dashboard.close': 'Close',
    'dashboard.focusTime': 'Focus Time',
    'dashboard.pomodoros': 'Pomodoros',
    'dashboard.tasks': 'Tasks',
    'dashboard.efficiency': 'Efficiency',
    'dashboard.completed': 'Completed',
    'dashboard.average': 'Average',
    'dashboard.goalProgress': 'Goal Progress',
    'dashboard.achievements': 'Achievements',
    'dashboard.insights': 'Insights',
    'dashboard.goals': 'Goals',
    'dashboard.dailyGoal': 'Daily Goal',
    'dashboard.weeklyGoal': 'Weekly Goal',
    'dashboard.achievements.firstPomodoro': 'First Pomodoro',
    'dashboard.achievements.weekStreak': '1 Week Streak',
    'dashboard.achievements.hundredPomodoros': '100 Pomodoros',
    'dashboard.achievements.monthStreak': '1 Month Streak',
    'dashboard.insights.bestDay': 'Your most productive day is Monday!',
    'dashboard.insights.consistentTime': 'Your most productive hours are 9-11 AM.',
    'dashboard.insights.breakReminder': 'Regular breaks improve your productivity.',

    // Study Room
    'studyRoom.studyWithMe': 'STUDY WITH ME',
    'studyRoom.createRoom': 'Create Room',
    'studyRoom.joinRoom': 'Join Room',
    'studyRoom.roomName': 'Room Name',
    'studyRoom.roomNamePlaceholder': 'Our study room',
    'studyRoom.capacity': 'Capacity',
    'studyRoom.people': 'people',
    'studyRoom.passwordProtected': 'Password protected',
    'studyRoom.roomType': 'Room type',
    'studyRoom.privateRoom': 'Private room',
    'studyRoom.anonymousRoom': 'Anonymous open room',
    'studyRoom.privateDescription': 'People you share the invite code with can join.',
    'studyRoom.anonymousDescription': 'Your identity and task details stay hidden.',
    'studyRoom.quickAnonymous': 'Join an available anonymous room',
    'studyRoom.openFocusName': 'Open Focus Room',
    'studyRoom.hideTaskDetails': 'Hide my task details from other participants',
    'studyRoom.breakChatOnly': 'Enable chat only during breaks',
    'studyRoom.password': 'Password',
    'studyRoom.passwordPlaceholder': 'Room password',
    'studyRoom.optional': 'optional',
    'studyRoom.roomId': 'Room ID',
    'studyRoom.roomIdPlaceholder': 'ABCD1234',
    'studyRoom.enterRoomName': 'Please enter room name',
    'studyRoom.enterPassword': 'Please enter a password with at least 6 characters',
    'studyRoom.enterRoomId': 'Please enter room ID',
    'studyRoom.roomCreated': 'Room created successfully!',
    'studyRoom.shareLink': 'Share link',
    'studyRoom.leaveRoom': 'Leave Room',
    'header.leaveRoom': 'Leave Room',
    'room.roomId': 'Room ID',
    'room.participants': 'Participants',
    'studyRoom.leaveRoomConfirm': 'Are you sure you want to leave the room?',
    'studyRoom.settings': 'Settings',
    'studyRoom.minimize': 'Minimize',
    'studyRoom.maximize': 'Maximize',
    'studyRoom.deviceSettings': 'Device Settings',
    'studyRoom.microphone': 'Microphone',
    'studyRoom.camera': 'Camera',
    'studyRoom.cameraOff': 'Camera Off',
    'studyRoom.muteMic': 'Mute Microphone',
    'studyRoom.unmuteMic': 'Unmute Microphone',
    'studyRoom.turnOffCamera': 'Turn Off Camera',
    'studyRoom.turnOnCamera': 'Turn On Camera',
    'studyRoom.typeMessage': 'Type a message...',
    'studyRoom.chatLocked': 'Chat is closed during a focus session',
    'studyRoom.status.preparing': 'Preparing',
    'studyRoom.status.focusing': 'Focusing',
    'studyRoom.status.break': 'On break',
    'studyRoom.status.paused': 'Paused',
    'studyRoom.microphoneError': 'Microphone access denied',
    'studyRoom.cameraError': 'Camera access denied',
    'studyRoom.copyLink': 'Copy Room Link',
    'studyRoom.linkCopied': 'Room link copied!',
    'timer.running': 'Running',
    'timer.paused': 'Paused',
    
    // Audio Controls
    'audio.startAudio': 'Start Voice Chat',
    'audio.stopAudio': 'Stop Voice Chat',
    'audio.mute': 'Mute',
    'audio.unmute': 'Unmute',
    'audio.connecting': 'Connecting...',
    'audio.connected': 'Voice chat active',
    'audio.disconnected': 'Voice chat disabled',
    'audio.error': 'Microphone access denied or not available',
    'audio.retry': 'Retry',
    'audio.participants': 'Participants',
    
    // Patreon Support
    'patreon.title': 'Support the Project',
    'patreon.description': 'This project can only survive with your support!',
    'patreon.supportButton': 'Support',
    'patreon.buttonTitle': 'Visit our Patreon page',
    'patreon.close': 'Close',
    'patreon.kreosusButton': 'Support on Kreosus',
    'patreon.kreosusTitle': 'Visit our Kreosus page',
    
    // Music Player
    'musicPlayer.title': 'Music Player',
    'musicPlayer.playlist': 'Playlist',
    'musicPlayer.pasteUrl': 'Paste YouTube URL...',
    'musicPlayer.play': 'Play',
    'musicPlayer.previous': 'Previous',
    'musicPlayer.next': 'Next',
    'musicPlayer.pause': 'Pause',
    'musicPlayer.playButton': 'Play',
    'musicPlayer.minimize': 'Minimize',
    'musicPlayer.restore': 'Restore',
    'musicPlayer.close': 'Close',
    
    // Room
    'room.joining': 'Joining room...',
    
    // General
    'general.close': 'Close',
    'general.back': 'Back',
    
    // Legal
    'legal.terms': 'Terms of Service',
    'legal.privacy': 'Privacy Policy',
    'legal.termsTitle': 'Terms of Service',
    'legal.privacyTitle': 'Privacy Policy',
    'legal.lastUpdated': 'Last updated:',
    
    // Footer
    'footer.support': 'Support on Patreon',
    'footer.show': 'Show footer',
    'footer.hide': 'Hide footer',
    'footer.kreosus': 'Support on Kreosus',
    
    // Support Modal
    'support.title': 'Support Pomofree',
    'support.subtitle': 'We need your support to make Pomofree better!',
    'support.body1': 'With your support via Kreosus (₺) or Patreon ($), we can make the app more powerful, add new features, and build our mobile apps.',
    'support.body2': 'Supporters get perks: request custom features, priority feedback, and even "order" a fully custom theme!',
    'support.patreon': 'Support via Patreon',
    'support.kreosus': 'Support via Kreosus',
    'support.notToday': 'Close for today',
    
    'legal.acceptance': '1. Acceptance of Terms',
    'legal.acceptanceText': 'By accessing and using Pomofree, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.',
    'legal.description': '2. Description of Service',
    'legal.descriptionText': 'Pomofree is a Pomodoro timer application that helps users manage their productivity through focused work sessions and breaks. The service includes timer functionality, task management, progress tracking, and study room features.',
    'legal.userAccounts': '3. User Accounts',
    'legal.userAccountsText': 'To access certain features of the service, you may be required to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.',
    'legal.acceptableUse': '4. Acceptable Use',
    'legal.acceptableUseText': 'You agree to use the service only for lawful purposes and in accordance with these terms. You may not:',
    'legal.useRestriction1': 'Use the service in any way that violates applicable laws or regulations',
    'legal.useRestriction2': 'Attempt to gain unauthorized access to any part of the service',
    'legal.useRestriction3': 'Interfere with or disrupt the service or servers connected to the service',
    'legal.useRestriction4': 'Use the service to transmit any harmful or malicious code',
    'legal.termsPrivacy': 'Privacy',
    'legal.privacyText': 'Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the service, to understand our practices.',
    'legal.disclaimer': '6. Disclaimer of Warranties',
    'legal.disclaimerText': 'The service is provided on an "as is" and "as available" basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.',
    'legal.limitation': '7. Limitation of Liability',
    'legal.limitationText': 'In no event shall Pomofree or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the service, even if Pomofree or a Pomofree authorized representative has been notified orally or in writing of the possibility of such damage.',
    'legal.termsChanges': '8. Changes to Terms',
    'legal.termsChangesText': 'We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new terms on this page. Your continued use of the service after any such changes constitutes your acceptance of the new terms.',
    'legal.contact': '9. Contact Information',
    'legal.contactText': 'If you have any questions about these Terms of Service, please contact us through our support channels.',
    'legal.introduction': '1. Introduction',
    'legal.introductionText': 'This Privacy Policy explains how Pomofree collects, uses, and protects your information when you use our service. We are committed to protecting your privacy and ensuring the security of your personal data.',
    'legal.informationWeCollect': '2. Information We Collect',
    'legal.personalInfo': 'Personal Information',
    'legal.personalInfoText': 'When you create an account, we may collect:',
    'legal.collect1': 'Email address',
    'legal.collect2': 'Username or display name',
    'legal.collect3': 'Profile information you choose to provide',
    'legal.usageInfo': 'Usage Information',
    'legal.usageInfoText': 'We automatically collect certain information about your use of the service:',
    'legal.usage1': 'Timer sessions and productivity data',
    'legal.usage2': 'Tasks and projects you create',
    'legal.usage3': 'Settings and preferences',
    'legal.usage4': 'Device information and browser type',
    'legal.howWeUse': '3. How We Use Your Information',
    'legal.howWeUseText': 'We use the information we collect to:',
    'legal.use1': 'Provide and maintain the service',
    'legal.use2': 'Process your account and manage your data',
    'legal.use3': 'Generate productivity reports and statistics',
    'legal.use4': 'Improve our service and develop new features',
    'legal.use5': 'Communicate with you about the service',
    'legal.dataStorage': '4. Data Storage and Security',
    'legal.dataStorageText': 'Your data is stored in your Pomofree account using industry-standard encryption and security measures.',
    'legal.dataSharing': '5. Information Sharing',
    'legal.dataSharingText': 'We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except:',
    'legal.share1': 'When required by law or legal process',
    'legal.share2': 'To protect our rights or the safety of our users',
    'legal.share3': 'With service providers who assist us in operating our service (under strict confidentiality agreements)',
    'legal.cookies': '6. Cookies and Tracking',
    'legal.cookiesText': 'We may use cookies and similar tracking technologies to enhance your experience, remember your preferences, and analyze usage patterns.',
    'legal.yourRights': '7. Your Rights',
    'legal.yourRightsText': 'You have the right to:',
    'legal.rights1': 'Access your personal data',
    'legal.rights2': 'Correct inaccurate information',
    'legal.rights3': 'Delete your account and data',
    'legal.rights4': 'Export your data',
    'legal.rights5': 'Opt out of certain data processing activities',
    'legal.dataRetention': '8. Data Retention',
    'legal.dataRetentionText': 'We retain your personal information for as long as your account is active or as needed to provide you with our service.',
    'legal.children': '9. Children\'s Privacy',
    'legal.childrenText': 'Our service is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13.',
    'legal.privacyChanges': '10. Changes to This Policy',
    'legal.privacyChangesText': 'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.'
  }
};
